import * as types from '@store/types'
import axios from 'axios'
import utils from './../utils/awards'

const state = {
  awardList: [],
  awardsShelf: {},
  awardsOptions: {
    page: 1,
    limit: 18,
    total: 0
  }
}

const getters = {
  [types.AWARDS_SHELF]: ({ awardsShelf }) => {
    return {
      ...awardsShelf,
      campaigns: awardsShelf.campaigns && awardsShelf.campaigns.data.map((campaign) => ({
        ...campaign,
        isAward: true,
        isPartner: false
      }))
    }
  },
  [types.AWARDS_LIST]: (state) => state.awardList,
  [types.AWARDS_OPTIONS]: (state) => state.awardsOptions
}

const mutations = {
  [types.AWARDS_LIST]: (state, payload) => {
    state.awardList = payload
  },

  [types.AWARDS_SHELF]: (state, payload) => {
    state.awardsShelf = payload
  },

  [types.AWARDS_OPTIONS]: (state, payload) => {
    state.awardsOptions = payload
  }
}

const actions = {
  [types.AWARDS_SHELF]: async ({ commit }) => {
    const response = await axios.get('/partners/awards')
    const awards = {
      menu_icon: 'award-star',
      name: 'Seu catálogo de prêmios',
      campaigns: (response && response.data) || [],
      is_home: true,
      isAward: true,
      permission: 'awards',
      route: {
        name: 'Premios'
      }
    }
    commit(types.AWARDS_SHELF, awards)
  },

  [types.GET_AWARDS_LIST]: async ({ commit }) => {
    const response = await axios.get('partners/awards?limit=18')
    const awards = (response.data.data)
    const options = {
      ...response.data.meta,
      page: 1,
      limit: 18
    }
    commit(types.AWARDS_LIST, awards)
    commit(types.AWARDS_OPTIONS, options)
    return awards
  },

  [types.GET_AWARDS_INCREASE]: async ({ commit, getters }, payload = {}) => {
    const { total } = getters[types.AWARDS_OPTIONS]
    const awards = getters[types.AWARDS_LIST]

    if (awards.length >= total) return true

    let options = getters[types.AWARDS_OPTIONS]

    options = {
      ...options,
      ...payload,
      current_page: options.current_page + 1,
      page: options.page + 1
    }

    commit(types.AWARDS_OPTIONS, options)

    const { data } = await axios.get(`partners/awards?page=${options.current_page}&limit=${options.limit}`)

    commit(types.AWARDS_LIST, [
      ...awards,
      ...data.data
    ])
  },

  [types.FIND_AWARD_PARTNER]: async ({ state }, payload) => {
    const response = await axios.get(`partners/awards?slug=${payload.partnerSlug}`)
    if (response && response.data && response.data.data.length > 0) {
    const award = response.data.data[0]
    if (award && award.campaigns && award.campaigns.length > 1) {
      award.campaigns = [{
        ...award.campaigns[0],
        eventData: {
          max_value: utils.formatAwardValues(award.campaigns).maxValue,
          min_value: utils.formatAwardValues(award.campaigns).minValue,
          prices_options: utils.formatAwardValues(award.campaigns).priceOptions,
          value: null
        },
        campaigns_reduced: utils.reduceCampaigns(award.campaigns)
      }]
    }
    return award
    }
    return null
  },

  [types.AWARD_RESCUE]: async ({ state, dispatch }, payload) => {
    try {
      const response = await axios.post(`/campaign/${payload.id}/event`, { value: payload.value })
      return response
    } catch (err) {}
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/awards.js